import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ManagerAccessLevelService} from "../../serverService/managerAccessLevelService/ManagerAccessLevelService";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoDivider,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoLabel,
    RaikoMultiSelectTable,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    prepareRaikoSelectBoxItem, RaikoSelectBox, RaikoLabelType, RaikoCustomTooltip, showDarkMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import RaikoSelectBoxTypeTwo, {
    prepareRaikoSelectBoxTypeTwoItem
} from "../../component/hostSelect/raikoSelectBoxTypeTwo/RaikoSelectBoxTypeTwo";
import {prev} from "stylis";

export default function ManagerAccessLevelDetails() {

    let page = 0;
    const size = 50;

    const {id: accessLevelDetailId = -1} = useParams()

    const service = new ManagerAccessLevelService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [title, setTitle] = useState("");
    const [name, setName] = useState("");

    const [permissionsFilters, setPermissionsFilters] = useState([]);
    const [permissionFilterLoading, setPermissionFilterLoading] = useState(false);
    const [selectedFilterItemId, setSelectedFilterItemId] = useState(-1);

    const [pageCount, setPageCount] = useState(0);
    const [accessList, setAccessList] = useState([]);
    const [accessSelectedItems, setAccessSelectedItems] = useState([]);
    const [accessTableLoadingState, setAccessTableLoadingState] = useState(false);


    useEffect(() => {
        if (typeof accessLevelDetailId !== 'undefined') {
            getDataFromServer()
            getFilter()
            getPermissions()
        }
    }, [accessLevelDetailId]);

    function getDataFromServer() {
        service.getRoleInfo(accessLevelDetailId)
            .then(response => {
                const permissions = []
                response.permissions.map((item) => {
                    permissions.push({
                        id: item.id,
                        name: item.title
                    })
                })
                setAccessSelectedItems(permissions)

                setTitle(response.title)
                setName(response.name)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {

        })
    }

    function getFilter() {
        setPermissionFilterLoading(true)
        service.getAccessFilters()
            .then(response => {
                setPermissionsFilters([
                    prepareRaikoSelectBoxTypeTwoItem(-1, "همــه", "")
                ])
                response.map((item, index) => {
                    setPermissionsFilters(prevState => [
                        ...prevState,
                        prepareRaikoSelectBoxTypeTwoItem(item.tagName, item.tagTitle, item.tagName)
                    ])
                })

                if (permissionsFilters && permissionsFilters.length > 0)
                    setSelectedFilterItemId(permissionsFilters[0].id)

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setPermissionFilterLoading(false)
        })

    }

    function getPermissions(tagFilter = selectedFilterItemId) {
        setAccessTableLoadingState(true)

        service.getPermissionsList(page, size, tagFilter !== -1 ? tagFilter : null)
            .then(response => {

                const _list = []
                response.data.map((item, index) => {
                    _list.push(
                        prepareRoleListRow(
                            (page * size) + index + 1,
                            item.id,
                            item.title,
                            item.tagTitle,
                            item.name
                        )
                    )
                })

                setAccessList(_list)
                setPageCount(response.totalPage)

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setAccessTableLoadingState(false)
        })
    }

    function prepareRoleListRow(number, id, name, tagTitle,roleName) {
        return {
            number,
            id,
            name,
            tagTitle,
            access: <RaikoCustomTooltip title={"کپی شناسه دسترسی"}>
                <div className={css`display: flex;width: 100%;justify-content: center;align-items: center;`}>
                    <div className={`ic-link ${css`cursor: pointer;`}`}
                         onClick={e => {
                             e.stopPropagation()
                             e.preventDefault()
                             navigator.clipboard.writeText(roleName)
                                 .then(_ => {
                                     showDarkMessage("شناسه دسترسی کپی شد.")
                                 }).catch(_ => {
                                 showErrorMessage("خطا در کپی لینک !")
                             })
                         }}/>
                </div>
            </RaikoCustomTooltip>
        }
    }


    function handleUpdateBaseInfo() {
        if (checkFields()) {
            loading.show()

            service.updateRoleInfo(
                accessLevelDetailId,
                name,
                title,
                accessSelectedItems
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد!")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })

        }
    }

    function checkFields() {
        let state = false
        let message = ""

        if (title.length === 0) {
            message = "لطفا نام دسترسی را وارد نمایید!"
        } else if (name.length === 0) {
            message = "لطفا slug را وارد نمایید!"
        } else if (accessSelectedItems.length === 0) {
            message = "لطفا دسترسی های مورد نظر را انتخاب نمایید!"
        } else {
            state = true
        }

        showErrorMessage(message)

        return state


    }

    function handleFilterPermissions(id) {
        setSelectedFilterItemId(id)
        getPermissions(id)
    }


    function handleChangePagination(newPage) {
        page = newPage;
        getPermissions()
    }

    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.ManagersAccessDetail.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>

                    <RaikoBreadcrumb breadCrumbItems={[

                        raikoBreadCrumbItemGenerator(
                            RouteHelper.ManagersAccess.name,
                            RouteHelper.ManagersAccess.globalUrl),
                        raikoBreadCrumbItemGenerator(
                            title ? title : name,
                            ""),
                    ]}/>

                    <RaikoBaseCardContainer>

                        <RaikoGridOneColumn>
                            <RaikoLabel text={"فیلتر ها"} raikoLabelType={RaikoLabelType.TITLE}/>

                            <RaikoSelectBoxTypeTwo
                                items={permissionsFilters}
                                loading={permissionFilterLoading}
                                selectedItem={selectedFilterItemId}
                                setSelectedItem={handleFilterPermissions}
                                isHorizontal={true}
                                iconClass={"ic-access-level"}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoSectionContainer
                                title={"اطلاعات پایه"}
                                hasActionButton
                                actionButtonOnclick={handleUpdateBaseInfo}
                            >
                                <RaikoGridOneColumn className={css`gap: 2rem`}>

                                    <RaikoGridTwoColumn>
                                        <RaikoSimpleInputOutlined labelText={"نام"} setValue={setTitle} value={title}/>
                                        <RaikoSimpleInputOutlined labelText={"Slug"} setValue={setName} value={name}/>
                                    </RaikoGridTwoColumn>

                                    <RaikoGridOneColumn className={css`gap: .75rem`}>
                                        <RaikoDivider/>
                                        <RaikoLabel text={"دسترسی ها"} className={css`font-weight: 900;
                                            font-family: iranYekanBold, sans-serif`}/>
                                        <RaikoDivider/>
                                        <RaikoMultiSelectTable
                                            pageCount={pageCount}
                                            setSelectedItems={setAccessSelectedItems}
                                            handleChangePagination={handleChangePagination}
                                            tableData={accessList}
                                            selectedItems={accessSelectedItems}
                                            tableHeader={accessTableHeader}
                                            tableLoadingState={accessTableLoadingState}
                                            reverseColumn={true}
                                        />
                                    </RaikoGridOneColumn>


                                </RaikoGridOneColumn>

                            </RaikoSectionContainer>

                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>

            </RaikoBaseContainer>
        </>
    )
}


const accessTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "name",
        label: "عنوان"
    },
    {
        id: "tagTitle",
        label: "دسته بندی"
    },
    {
        id: "access",
        label: "ROLE_NAME"
    }
]
